<script>
import { mapGetters } from 'vuex';
import { MESSAGE_VARIABLES } from 'shared/constants/messages';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
    // Opt-in allow-list of static MESSAGE_VARIABLES keys to offer. When empty
    // (the default), every static token is offered — today's exact behavior for
    // every shared consumer (ReplyBox, AddCanned, WeeklyAvailability...). When
    // non-empty, only the listed static tokens are kept; custom attributes are
    // always offered regardless, since they resolve via the contact's
    // custom_attributes. The ongoing-campaign editor uses it to curate the
    // picker down to a focused, reliably-useful set (a UX filter — not a
    // resolve/no-resolve rule).
    variableKeys: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      customAttributes: 'attributes/getAttributes',
    }),
    items() {
      return [
        ...this.standardAttributeVariables,
        ...this.customAttributeVariables,
      ];
    },
    standardAttributeVariables() {
      return MESSAGE_VARIABLES.filter(variable => {
        // Opt-in curation: when variableKeys is provided, drop any static token
        // not on the allow-list. Empty list = no curation (default consumers).
        if (
          this.variableKeys.length &&
          !this.variableKeys.includes(variable.key)
        ) {
          return false;
        }
        return (
          variable.label.includes(this.searchKey) ||
          variable.key.includes(this.searchKey)
        );
      }).map(variable => ({
        label: variable.key,
        key: variable.key,
        description: variable.label,
      }));
    },
    customAttributeVariables() {
      return this.customAttributes.map(attribute => {
        const attributePrefix =
          attribute.attribute_model === 'conversation_attribute'
            ? 'conversation'
            : 'contact';

        return {
          label: `${attributePrefix}.custom_attribute.${attribute.attribute_key}`,
          key: `${attributePrefix}.custom_attribute.${attribute.attribute_key}`,
          description: attribute.attribute_description,
        };
      });
    },
  },
  methods: {
    handleVariableClick(item = {}) {
      this.$emit('click', item.key);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    type="variable"
    :items="items"
    @mentionSelect="handleVariableClick"
  />
</template>

<style scoped>
.variable--list-label {
  font-weight: var(--font-weight-bold);
}
</style>
